/*
 * @Author: Sam
 * @Date: 2020-10-12 15:23:33
 * @LastEditTime: 2022-01-07 15:47:19
 * @LastEditors: Sam
 * @Description:
 * @FilePath: \resourcesf:\thework\tofba-client\src\store\getters.js
 * @可以输入预定的版权声明、个性签名、空行等
 */
const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  language: state => state.app.language,
  loading: state => state.app.loading,
  channelFormLeft: state => state.createWaybill.channelFormLeft,
  channelFormRight: state => state.createWaybill.channelFormRight,
  selectedImporterInfo: state => state.createWaybill.selectedImporterInfo,
  invoiceInfo: state => state.createWaybill.invoiceInfo,
  packingInfo: state => state.createWaybill.packingInfo,
  // waybillRender: state => state.createWaybill.initWaybillRender,
  createTpye: state => state.createWaybill.createTpye,
  publicData: state => state.public.publicData,
  isCheckPrice: state => state.user.isCheckPrice,
  userInfo: state => state.user.userInfo,
  showWarehouseInfo: state => state.user.showWarehouseInfo,
  siteData:  state => state.app.siteData,
}
export default getters
